"use client";

import { Award, Download, Shield, Sparkles, Syringe } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Compliance() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const standards = [{
    icon: Shield,
    title: "Regulatory Compliance",
    description: "We strictly adhere to international medical device regulations, ensuring all imported technologies meet rigorous safety and quality standards for global distribution."
  }, {
    icon: Syringe,
    title: "Clinical Evaluation",
    description: "Every product undergoes a comprehensive clinical assessment by our expert team to verify efficacy, safety, and long-term value for healthcare providers."
  }, {
    icon: Sparkles,
    title: "Quality Assurance",
    description: "We partner exclusively with manufacturers holding ISO 13485 and CE certifications, guaranteeing premium quality and reliability in every medical device we distribute."
  }, {
    icon: Award,
    title: "Global Standards",
    description: "Our distribution network operates under strict international protocols, providing full traceability and regulatory support for all medical devices across all markets."
  }];
  const certifications = ["ISO 13485 CERTIFIED", "CE MARK COMPLIANT", "FDA REGULATORY SUPPORT", "GLOBAL QUALITY STANDARDS", "CLINICAL VALIDATION"];
  return <section data-section-id="32" id="complianceandcertifications" className="py-24 md:py-32 lg:py-40 px-6 md:px-10 font-default bg-background text-foreground">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`text-center mb-20 md:mb-28 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-default text-xs md:text-sm tracking-widest uppercase mb-8 text-blue-600">
            03 / COMPLIANCE & QUALITY
          </p>
          <h1 className="font-default text-5xl md:text-7xl lg:text-8xl font-bold leading-[0.95] tracking-tight text-slate-900">
            Global Regulatory
            <br />
            <span className="italic text-blue-600">Excellence.</span>
          </h1>
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 relative">
          {standards.map((item, i) => {
          const Icon = item.icon;
          return <div data-index={i} key={i} className={`relative p-8 md:p-10 transition-all duration-700 ease-out rounded-lg shadow-md ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} ${i % 2 === 1 ? "sm:border-l" : ""} ${i >= 2 ? "sm:border-t lg:border-t-0" : ""} ${i > 0 ? "lg:border-l border-t sm:border-t-0" : ""}`} style={{
            transitionDelay: `${i * 120}ms`,
            borderColor: "var(--border)"
          }}>
                <Icon className="w-16 h-16 mb-8 text-blue-600" strokeWidth={1} />
                <h2 className="font-default text-2xl font-semibold leading-tight mb-4 text-slate-900">
                  {item.title}
                </h2>
                <p className="text-sm leading-relaxed font-default text-slate-600">
                  {item.description}
                </p>
              </div>;
        })}
        </div>

        {}
        <div ref={footerRef} className={`mt-24 md:mt-32 transition-all duration-700 ease-out ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6 mb-16 md:mb-20">
            {certifications.map((cert, i) => <span data-index={i} key={i} className="font-default text-xs tracking-widest uppercase text-slate-500">
                {cert}
              </span>)}
          </div>

          {}
          <div className="flex justify-center">
            <Button variant="outline" size="lg" className="font-default text-xs tracking-widest uppercase bg-blue-600 text-white border-2 border-blue-600 px-8 py-6 h-auto transition-colors duration-300 hover:bg-blue-700 rounded-lg">
              <Download className="w-4 h-4 mr-2" strokeWidth={1.5} />
              Download Compliance Dossier (PDF)
              <span aria-hidden="true">→</span>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}